/* eslint-disable prettier/prettier */

export const getInterviewerProfile = /* GraphQL */ `
  query GetInterviewerProfile($id: ID!) {
    getInterviewer(id: $id) {
      id
      isBarRaiserInterviewer
      loopEventID
      participantConfigID
      phoneScreenID
      profile {
        alias
        id
        name
      }
      sourceOrgID
      interviewerRole
    }
  }
`;
